import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hub } from 'aws-amplify/utils';
import { getCurrentUser } from '../services/auth';
import useStore from '../store';

export default function OAuthCallback() {
  const navigate = useNavigate();
  const setUser = useStore((s) => s.setUser);

  useEffect(() => {
    const unsubscribe = Hub.listen('auth', async ({ payload }) => {
      if (payload.event === 'signInWithRedirect') {
        const user = await getCurrentUser();
        setUser(user);
        navigate('/', { replace: true });
      }
      if (payload.event === 'signInWithRedirect_failure') {
        navigate('/login', { replace: true });
      }
    });

    // Fallback: check if user is already signed in after redirect
    (async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          setUser(user);
          navigate('/', { replace: true });
        }
      } catch {
        // Still waiting for Hub event
      }
    })();

    const timeout = setTimeout(() => navigate('/login', { replace: true }), 8000);
    return () => {
      unsubscribe();
      clearTimeout(timeout);
    };
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600 mx-auto mb-4" />
        <p className="text-gray-600 dark:text-gray-400">Signing you in...</p>
      </div>
    </div>
  );
}
